import {
    isPasswordMinLengthMet,
    passwordMinLengthMsg,
    passwordOneLetterMsg,
    passwordOneUppercaseSpecialMsg,
    regexAtLeastOneLetter,
    regexAtLeastOneUpperCaseNumberSpecial,
} from '@/schemas/Password.schema';

/**
 * Validates a password against all criteria and returns an array of error messages
 * for criteria that are not met. This is useful for displaying password criteria
 * indicators when form validation only returns the first failing error.
 *
 * @param password - The password string to validate
 * @returns Array of error messages for criteria that are not met
 */
export const validatePasswordCriteria = (password: string): string[] => {
    const errors: string[] = [];

    if (!isPasswordMinLengthMet(password)) {
        errors.push(passwordMinLengthMsg);
    }
    if (!regexAtLeastOneLetter.test(password)) {
        errors.push(passwordOneLetterMsg);
    }
    if (!regexAtLeastOneUpperCaseNumberSpecial.test(password)) {
        errors.push(passwordOneUppercaseSpecialMsg);
    }

    return errors;
};
